import PhoneNumber from 'awesome-phonenumber'

export const processInput = (key, value, validators) => {
	let processedValue = value
	if (validators.includes('isPhoneNumber')) {
		const phoneNumber  = new PhoneNumber(processedValue || '', 'US')
		if (phoneNumber.isValid()) {
		  processedValue = phoneNumber.getNumber('national')
		} else {
		  processedValue = processedValue.replace(/\D/g, '')
		}
	}
	if (validators.includes('isNumber')) {
		processedValue = processedValue.replace(/\D/g, '')
	}
	return { [key]: processedValue }
}
